module.exports = __webpack_public_path__ + "img/root111.f3ad0a9a.png";